import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router'
import { useAuth } from '@/contexts/AuthContext'
import { AppSidebar } from '@/components/layout/AppSidebar'
import { useEffect, useState } from 'react'
import { seedDefaultAccounts } from '@/services/firestore'
import { LoadingSpinner } from '@/components/ui/loading-spinner'

export const Route = createFileRoute('/admin')({
  component: AdminLayout,
})

function AdminLayout() {
  const { user, loading } = useAuth()
  const [initDone, setInitDone] = useState(false)

  // Initialize default chart of accounts once on first admin load
  useEffect(() => {
    if (user) {
      seedDefaultAccounts()
        .catch(console.error)
        .finally(() => setInitDone(true))
    }
  }, [user])

  if (loading || (user && !initDone)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-blue-50">
        <LoadingSpinner size="3xl" text="Loading dashboard..." />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" />
  }

  return (
    <div className="flex h-screen w-full overflow-hidden bg-blue-50/40">
      <AppSidebar />
      <main className="flex-1 overflow-y-auto relative bg-[#f0f5ff]">
        <Outlet />
      </main>
    </div>
  )
}

